import { Component } from "react";
import equal from "fast-deep-equal";

export abstract class DeepPureStateComponent<T, S> extends Component<T, S> {
    public shouldComponentUpdate(props: T, state: S) {
        return !equal(this.props, props) || !equal(this.state, state);
    }
}
